<template>
  <button type="button" class="task_checkbox" :class="builtClasses" :disabled="disabled" @click="handleBtnClick">
    <CrossIcon v-if="isCrossIcon"/>
    <PlayIcon v-if="isPlayIcon"/>
    <PauseIcon v-if="isPauseIcon"/>
    <TickIcon v-if="isDefaultIcon"/>
  </button>
</template>

<script>
import TickIcon from '../../icons/Tasks/TickIcon';
import CrossIcon from '../../icons/Tasks/CrossIcon';
import PlayIcon from '../../icons/Tasks/PlayIcon';
import PauseIcon from '../../icons/Tasks/PauseIcon';

export default {
  components: { PauseIcon, PlayIcon, CrossIcon, TickIcon },

  props: {
    size: {
      required: false,
      default: 'small',
    },
    type: {
      required: false,
    },
    disabled: {
      required: false,
      default: false,
    },
    isPlayIcon: {
      required: false,
      default: false,
    },
    isCrossIcon: {
      required: false,
      default: false,
    },
    isPauseIcon: {
      required: false,
      default: false,
    },
  },

  computed: {
    builtClasses () {
      return {
        tb_small: this.size === 'small',
        tb_medium: this.size === 'medium',
        tb_large: this.size === 'large',
        tb_success: this.type === 'success',
        tb_primary: this.type === 'primary',
        tb_secondary: this.type === 'secondary',
        tb_danger: this.type === 'danger',
      };
    },

    isDefaultIcon () {
      return !this.isPauseIcon && !this.isPlayIcon && !this.isCrossIcon;
    },
  },

  methods: {
    handleBtnClick (e) {
      this.$emit('clicked', e);
    },
  },
};
</script>

<style scoped lang="scss">
.task_checkbox {
  border: solid #d5d5d5 1px;
  border-radius: 4px;
  outline: none;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
  padding: 0;
  margin: 0 4px;

  &[disabled] {
    cursor: default !important;
  }

  &.tb_small {
    width: 25px;
    height: 25px;
  }

  &.tb_medium {
    width: 30px;
    height: 30px;
  }

  &.tb_large {
    width: 35px;
    height: 35px;
  }

  &.tb_primary {
    background-color: #0096f5;
    color: #fff;
    border: 0;
  }

  &.tb_secondary {
    background-color: #c2c2c2;
    color: #fff;
    border: 0;
  }

  &.tb_success {
    background-color: #2ecc71;
    color: #fff;
    border: 0;
  }

  &.tb_danger {
    background-color: #f44;
    color: #fff;
    border: 0;
  }
}
</style>
